import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "favorite-icon-wrapper" }
const _hoisted_3 = { class: "flag-container" }
const _hoisted_4 = {
  key: 1,
  class: "flag-border"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "draw-info" }
const _hoisted_7 = { class: "countdown" }
const _hoisted_8 = { class: "time-block" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "time-block" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "time-block" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = {
  key: 1,
  class: "bet-button",
  disabled: ""
}

import { getGameLogoUrl } from '@/utils/resultParser';
import type { UpcomingDraw } from '@/types/lottery';

import { useIntegrationMode } from '@/composables/useIntegrationMode';
import CountryAvatar from '@/components/base/CountryAvatar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VerticalLotteryCard',
  props: {
    lottery: {},
    isFavorited: { type: Boolean },
    countdown: {},
    favoriteIcon: {},
    favoriteFilledIcon: {},
    betClosed: { type: Boolean }
  },
  emits: ['favorite', 'bet', 'navigate'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const { isLite } = useIntegrationMode();

const navigateToDetail = () => {
  emit('navigate');
};

const handleCardClick = (event: MouseEvent) => {
  if (event.target === event.currentTarget) {
    navigateToDetail();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "draw-card vertical",
    tabindex: "0",
    role: "button",
    onClick: handleCardClick
  }, [
    _createElementVNode("div", {
      class: "card-top",
      onClick: navigateToDetail
    }, [
      _createElementVNode("h3", {
        class: "lottery-name",
        title: _ctx.lottery.game_name
      }, _toDisplayString(_ctx.lottery.game_name), 9, _hoisted_1),
      (!_unref(isLite))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["favorite-btn", { active: _ctx.isFavorited }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('favorite')), ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createElementBlock("svg", {
                viewBox: "0 0 24 24",
                class: _normalizeClass(["favorite-icon-svg", { filled: _ctx.isFavorited }]),
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("path", { d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" }, null, -1)
              ]), 2))
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "card-middle",
      onClick: navigateToDetail
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(isLite))
          ? (_openBlock(), _createBlock(CountryAvatar, {
              key: 0,
              country: _ctx.lottery.country,
              "fallback-label": _ctx.lottery.game_name,
              size: "md"
            }, null, 8, ["country", "fallback-label"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo, _ctx.lottery.game_slug),
                alt: _ctx.lottery.country,
                class: "flag"
              }, null, 8, _hoisted_5)
            ]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(String(_ctx.countdown.hours).padStart(2, '0')), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('time.hours')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(String(_ctx.countdown.minutes).padStart(2, '0')), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('time.mins')), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(String(_ctx.countdown.seconds).padStart(2, '0')), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('time.secs')), 1)
          ])
        ])
      ])
    ]),
    (!_ctx.betClosed)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "bet-button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('bet')), ["stop"]))
        }, _toDisplayString(_ctx.$t('betslip.betNow')), 1))
      : (_openBlock(), _createElementBlock("button", _hoisted_17, _toDisplayString(_ctx.$t('betslip.betClosed')), 1))
  ]))
}
}

})